<template>
  <div :class="$style.wrapper">
    <v-hex />
    <v-labels :stageNumber="4" :currentStageNumber="4"/>

    <div :class="$style.inner">
      <div :class="$style.title">
        Ты набрал – <vue-hacker-text :class="$style.hack" speed="slow" :probability="0.8" :text="resultText" />
      </div>
      <div :class="$style.form">
        <v-btn large color="black" @click="click">ПОЛУЧИТЬ Сертификат</v-btn>
      </div>

      <div :class="$style.title">
        Твои награды
      </div>
      <div :class="$style.achievement">
        <div v-for="(achievement, index) in achievements" :key="index">
          <transition name="bounce-fast" mode="out-in">
            <img src="./assets/lock.svg" alt="lock" v-if="!achievement" :class="$style.lock">
            <div v-else :class="$style.item" :style="{ backgroundImage: `url(${achievement.img})`}"></div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import plural from '@/utils/plural'
import saveDataMixin from '@/mixins/saveData'

export default {
  name: 'hub',
  mixins: [saveDataMixin],
  mounted() {
    this.$store.commit('SET_HEX_COLOR', 'green')
  },
  methods: {
    click() {
      this.saveData({})
    },
  },
  computed: {
    result() {
      return this.$store.state.result
    },
    resultText() {
      return `${this.result} ${plural(this.result, 'балл', 'балла', 'баллов')}`
    },
    achievements() {
      return this.$store.state.achievements
    },
  },
}
</script>
<style lang="scss" module>
.wrapper {
  height: 100%;
}

.inner {
  transform: translateZ(0);
  padding: 0 2rem;
  padding-top: 18rem;
}

.title {
  font-size: 7.2rem;
  line-height: 1.1944444444;
  margin-bottom: 3rem;
  font-weight: bold;
  display: flex;
}

.hack {
  margin-left: 1rem;
}

.form {
  display: flex;
  margin-bottom: 6rem;

  & > div + div {
    margin-top: 0 !important;
    margin-left: 1rem;
  }

  button {
    margin-left: 1rem;
    width: 25.6rem;
  }
}

.achievement {
  display: flex;

  div {
    width: 7rem;
    height: 7rem;
    background: url(./assets/achivments.svg) no-repeat center;
    background-size: contain;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  div + div {
    margin-left: 0.7rem;
  }
}

</style>
